var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H4.372C5.232 0 5.982 0.586 6.191 1.42L7.296 5.843C7.38554 6.201 7.36746 6.57746 7.24401 6.92522C7.12055 7.27299 6.89723 7.57659 6.602 7.798L5.309 8.768C5.174 8.869 5.145 9.017 5.183 9.12C5.74738 10.6549 6.6386 12.0487 7.79495 13.2051C8.9513 14.3614 10.3451 15.2526 11.88 15.817C11.983 15.855 12.13 15.826 12.232 15.691L13.202 14.398C13.4234 14.1028 13.727 13.8794 14.0748 13.756C14.4225 13.6325 14.799 13.6145 15.157 13.704L19.58 14.809C20.414 15.018 21 15.768 21 16.629V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H15.75C7.052 21 0 13.948 0 5.25V3Z",
    fill: "#00BB31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.b529a2fad06ab97b0fa99c380b949608.svg";
export { ForwardRef as ReactComponent };